import React from 'react';
import Select from 'src/components/Select';
import { CategoryResource } from 'src/helpers/api/categories';
import { FormattedMessage } from 'react-intl';
import { WrappedFieldProps } from 'redux-form';
import { FieldProps } from 'src/helpers/forms';

type Props = {
  categories: CategoryResource[];
  id?: string;
  labelClassName?: string;
  onSelectionChanged?: (category: { categoryName: string }) => void;
};

type ReduxProps = Props & WrappedFieldProps;

type FormikProps = Props & FieldProps;

const CategoryField: React.StatelessComponent<ReduxProps> = ({
  categories,
  input,
  labelClassName,
  onSelectionChanged,
}) => (
  <div id="category-field" className="row">
    <div className="jg-form-group col-xs-12">
      <label className={`${labelClassName} jg-form-label`} htmlFor="category">
        <FormattedMessage id="CategoryField.label" defaultMessage="Category" />
      </label>
      <Select
        items={categories.map(category => ({
          value: category.id.toString(),
          label: category.name,
          isSelected: category.id === input.value,
        }))}
        placeholder="Choose a category"
        onChange={selectedCategory => {
          input.onChange(selectedCategory.value);
          if (onSelectionChanged) {
            onSelectionChanged({ categoryName: selectedCategory.label });
          }
        }}
      />
    </div>
  </div>
);

const CategoryFieldFormik: React.StatelessComponent<FormikProps> = ({
  categories,
  input,
  labelClassName,
  onSelectionChanged,
}) => (
  <div id="category-field" className="row">
    <div className="jg-form-group col-xs-12">
      <label className={`${labelClassName} jg-form-label`} htmlFor="category">
        <FormattedMessage id="CategoryField.label" defaultMessage="Category" />
      </label>
      <Select
        items={categories.map(category => ({
          value: category.id.toString(),
          label: category.name,
          isSelected: category.id === input.value,
        }))}
        placeholder="Choose a category"
        onChange={selectedCategory => {
          input.onChange(selectedCategory.value);
          if (onSelectionChanged) {
            onSelectionChanged({ categoryName: selectedCategory.label });
          }
        }}
      />
    </div>
  </div>
);

export default CategoryField;

export { CategoryFieldFormik };



// WEBPACK FOOTER //
// ./src/components/CategoryField/CategoryField.tsx